import { c as _c } from "react/compiler-runtime";
import { Divider, LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { getLogger } from '@/idv2/utils/logger';
const {
  logInfo
} = getLogger({
  name: 'identify-different-account'
});
export type DifferentAccountOptionProps = {
  onReset: () => void;
};

/**
 * When bootstrap data matches an existing user, show the option to log in with a different account.
 * Clicking it creates a new identify session (no bootstrap) and redirects to /identify.
 */
export const DifferentAccountOption = t0 => {
  const $ = _c(15);
  const {
    onReset
  } = t0;
  const {
    t
  } = useTranslation("idv2");
  let t1;
  if ($[0] !== onReset) {
    t1 = () => {
      logInfo("Login with different account");
      onReset();
    };
    $[0] = onReset;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Divider variant="secondary" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="relative isolate w-full min-h-6 flex justify-center items-center">{t2}<div className="text-sm text-quaternary bg-primary p-2 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-2">{t3}</div></div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp2);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleClick || $[10] !== t5) {
    t6 = <div className="flex flex-row justify-center w-full"><LinkButton onClick={handleClick} data-dd-action-name="different-account:cta">{t5}</LinkButton></div>;
    $[9] = handleClick;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className="flex flex-col gap-6 mt-2">{t4}{t6}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
function _temp($) {
  return $.identify.login.or;
}
function _temp2($_0) {
  return $_0.identify.login.differentAccount;
}